import { PerspectiveCamera, Vector3 } from 'three';
import { smooth } from './useScrollScene';

function projectLabels(labels, { width, height, eye, target, fov, projection } = {}) {
  if (width < 1100 || !eye || !target || !fov || !height) return [];
  // Reuse the renderer's camera snapshot; never alter the live scene or its camera.
  const camera = new PerspectiveCamera(fov, width / height, .04, 180);
  camera.position.fromArray(eye);
  camera.lookAt(...target);
  camera.updateMatrixWorld(true);
  if (projection) camera.projectionMatrix.fromArray(projection);
  return labels.flatMap(([text, point]) => {
    const position = new Vector3(...point);
    if (position.clone().applyMatrix4(camera.matrixWorldInverse).z >= 0) return [];
    position.project(camera);
    return [{ text, x: Math.max(width * .55, Math.min(width - 195, (position.x * .5 + .5) * width)), y: (-position.y * .5 + .5) * height }];
  });
}

export function projectCraftLabels(progress, frame) {
  if (progress >= .30) return [];
  const gap = 1.35 + (.36 - 1.35) * smooth(0, .30, progress);
  const labels = gap < .65
    ? [['Knowledge \u00b7 actions \u00b7 controls', [2.50, 0, 0]]]
    : [['Agent', [1.05, gap + 1.05, 0]], ['Controls', [2.50, gap, 0]], ['Actions', [2.50, 0, 0]], ['Knowledge', [2.50, -gap, 0]]];
  return projectLabels(labels, frame);
}

export function projectHomeLabels(progress, frame) {
  if (progress < .58 || progress > .76) return [];
  const opacity = smooth(.58, .62, progress) * (1 - smooth(.70, .76, progress));
  return projectLabels([
    ['Agent', [-1.15, 1.65, -25]], ['Controls', [-.25, .64, -24.65]],
    ['Actions', [-.25, 0, -25]], ['Knowledge', [-.25, -.64, -25.35]],
  ], frame).map(label => ({ ...label, opacity }));
}
